import { AllAuthUserProfile } from '../auth/profileApi';

export const tdAllAuthProfiles: AllAuthUserProfile[] = [
  {
    id: 'f0e1d2c3-0000-4000-8000-000000000001',
    email: 'mobilix-workorder-admin@allbinary.se',
    tenant_id: 'lts',
    tenant: 'Region Sörmland',
    role_id: '11111111-0000-4000-8000-000000000001',
    role: 'Administratör',
    application_id: '8e9c0aaf-1ddd-47eb-a2a2-bf4d1711724c',
    application: 'Mobilix',
    active: true,
  },
  {
    id: 'f0e1d2c3-0000-4000-8000-000000000002',
    email: 'mobilix-workorder-contractor-admin@allbinary.se',
    tenant_id: 'vl',
    tenant: 'Region Västmanland',
    organization_id: '41c084fc-c39f-4e85-bd35-9921b5c10cc0',
    organization: 'Björnligan tvätt',
    role_id: '11111111-0000-4000-8000-000000000002',
    role: 'Entreprenörsadministratör',
    application_id: '8e9c0aaf-1ddd-47eb-a2a2-bf4d1711724c',
    application: 'Mobilix',
    active: true,
  },
  // Deactivated profile: must be filtered out by ProfileSelectorScreen.
  {
    id: 'f0e1d2c3-0000-4000-8000-000000000003',
    email: 'mobilix-workorder-admin@allbinary.se',
    tenant_id: 'vl',
    tenant: 'Region Västmanland',
    role_id: '11111111-0000-4000-8000-000000000001',
    role: 'Administratör',
    application_id: '8e9c0aaf-1ddd-47eb-a2a2-bf4d1711724c',
    application: 'Mobilix',
    active: false,
  },
];
